import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class WorkflowHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.workflow_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.workflow_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.workflow_create, (workflow_id: string) => {
            this.broadcast(SharedEventNameEnum.workflow_create, { workflow_id });
        });

        this.on(SharedEventNameEnum.workflow_name_update, (workflow_id: string, name: string) => {
            this.broadcast(SharedEventNameEnum.workflow_name_update, { workflow_id, name });
        });

        this.on(SharedEventNameEnum.workflow_order_update, (workflow_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.workflow_order_update, { workflow_id, order_index });
        });

        this.on(SharedEventNameEnum.workflow_delete, (workflow_id: string) => {
            this.broadcast(SharedEventNameEnum.workflow_delete, { workflow_id });
        });

        this.on(SharedEventNameEnum.workflow_node_upsert, (workflow_id: string) => {
            this.broadcast(SharedEventNameEnum.workflow_node_upsert, { workflow_id });
        });

        this.on(SharedEventNameEnum.workflow_node_delete, (workflow_id: string, node_id: string) => {
            this.broadcast(SharedEventNameEnum.workflow_node_delete, { workflow_id, node_id });
        });

        this.on(
            SharedEventNameEnum.workflow_execution_start,
            (workflow_id: string, execution_id: number, project_id: string | null) => {
                this.broadcast(SharedEventNameEnum.workflow_execution_start, { workflow_id, execution_id, project_id });
            },
        );

        this.on(
            SharedEventNameEnum.workflow_execution_finish,
            (workflow_id: string, execution_id: number, status: string, error: string | null, project_id: string | null) => {
                this.broadcast(SharedEventNameEnum.workflow_execution_finish, { workflow_id, execution_id, status, error, project_id });
            },
        );
    };
}
